import { createAsyncThunk } from "@reduxjs/toolkit";
import { readCache } from "./utils.js";

const COMMENTS_CACHE_PREFIX = "comments_cache:";

export const hydrateCommentsFromCache = createAsyncThunk(
  "comments/hydrateCommentsFromCache",
  async ({ postId }, { rejectWithValue }) => {
    try {
      const cached = readCache(`${COMMENTS_CACHE_PREFIX}${postId}`);
      return { postId, comments: cached || [] };
    } catch (e) {
      return rejectWithValue(e?.message || "Failed to hydrate comments");
    }
  },
);
